import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse,  HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw'
import 'rxjs/add/operator/catch';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    return next.handle(req)
        .catch((response: any) => {
          if (response.status >= 400){
            return this.handle400(response);
          }

          if (response.status >= 500){
            return this.handle500(response);
          }

          return Observable.throw(response);
        });
  }

  /**
   * Validation failed - Will need to show validation messages
   * @param response
   * @returns {ErrorObservable}
     */
  private handle400(response){
    return Observable.throw(response);
  }

  /**
   * Something went wrong inside the script
   * @param response
     */
  private handle500(response){
    return Observable.throw(response);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/error.interceptor.ts